module.exports = {"632621100":"大武镇","632621101":"拉加镇","632621200":"大武乡","632621201":"东倾沟乡","632621202":"雪山乡","632621203":"下大武乡","632621204":"优云乡","632621205":"当洛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632621.json
// module id = 3005
// module chunks = 0